var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgCantBeer = function SvgCantBeer(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "19px",
    "aria-hidden": "true",
    viewBox: "0 0 17 19",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Booking-Quick-Wins",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-856.000000, -1301.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(856.000000, 1302.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "can_beer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filled_Icons",
    transform: "translate(0.666667, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5786667,1.108 C12.5153333,1.04 12.4266667,1 12.3333333,1 L2.33333333,1 C2.23933333,1 2.15066667,1.04 2.08733333,1.108 C2.024,1.17733333 1.99266667,1.26933333 2.00133333,1.36266667 L3.33466667,16.696 C3.34933333,16.8686667 3.49333333,17 3.66666667,17 L11,17 C11.1726667,17 11.3173333,16.8686667 11.332,16.696 L12.6653333,1.36266667 C12.6733333,1.26933333 12.642,1.17733333 12.5786667,1.108 Z M11.564,6.33333333 L3.102,6.33333333 L2.69666667,1.66666667 L11.9693333,1.66666667 L11.564,6.33333333 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.833333,13.5 L1.323337,0.990003997",
    id: "Path-2-Copy",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7710057,16.4376727 L0.333333,2",
    id: "Path-2",
    stroke: "#C62828",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "invisible_shape",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })))))))));
};
var Memo = /*#__PURE__*/memo(SvgCantBeer);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "transfix-icons/icons/CantBeer.a1ff035369f01d32139e0c1be9f605a1.svg";